import { render } from "./ResultsBibliography.vue?vue&type=template&id=070489a4&scoped=true"
import script from "./ResultsBibliography.vue?vue&type=script&lang=js"
export * from "./ResultsBibliography.vue?vue&type=script&lang=js"

import "./ResultsBibliography.vue?vue&type=style&index=0&id=070489a4&scoped=true&lang=css"

import exportComponent from "/data/local/webspace/artflsrv04/html/philologic4.7/publicdicos/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-070489a4"]])

export default __exports__